import {formatComment} from '../../filters/index.js'
import { mapState } from 'vuex'
import {formatTime} from '@/filters/index.js'
import {
  getNewsCommentsList,
  getNewsDetail,
  supportArticle,
  unSupportArticle
} from '@/api'
import asTop from '@/assets/article-comment/asTop.png'
export default {
  name: 'launcher-comment',
  data() {
    return {
      defaultAvatar: 'https://wechat-gjqt.jinyi999.cn/mangement-fronted/production/1520490845601_avatar.png',
      isThumbed: '',
      currentRoute: '',
      likeNum: '',
      likeDiffNum: 1,
      thumbUsers: [],
      isGetComment: false,
      asTop
    }
  },
  props: {
  },
  watch: {
    articleInfo(newVal) {
      if(!newVal) return;
      this.initComment()
    },
    wechatUser () {
      this.initComment()
    }
  },
  computed: {
    classObj() {
      return {
        'thumb-click': this.isThumbed,
        'thumb-cancel': !this.isThumbed
      }
    },
    ...mapState(['wechatUser', 'serviceConfig']),
    ...mapState('comment', {
      commentList: state => state.commentList
    }),
    ...mapState('article', {
      articleInfo: state => state.cacheArticle
    }),
    articleId() {
      return this.articleInfo && this.articleInfo.attribute && this.articleInfo.attribute.circleNewsId
    },
    readNum() {
      return this.articleInfo.hitCount
    },
    type() {
      if(this.articleInfo.dataType === 3) {
        return 'article'
      } else if(this.articleInfo.dataType === 4) {
        return 'video'
      } else {
        return ''
      }
    }
  },
  created() {
    if(this.articleId) {
      this.initComment()
    }
    this.currentRoute = this.$router.history.current.fullPath
  },
  methods: {
    initComment() {
      if (!this.articleId || !this.wechatUser.token || !this.serviceConfig.appCode || this.isGetComment) return
      this.getNewsDetail()
      this.getArticleComments()
    },
    async getArticleComments() {
      const {data: res} = await getNewsCommentsList(this.articleId, this.wechatUser.token, this.serviceConfig.appCode)
      if(res.code === 1) this.$store.dispatch('comment/set_cache_comment_list', res.data)
    },
    async getNewsDetail() {
      const res = await getNewsDetail(this.articleId, this.wechatUser.token, this.serviceConfig.appCode)
      this.isGetComment = true
      const {data: {data, code}} = res
      if (code !== 1) return
      this.likeNum = data.supportCount + this.articleInfo.basePraisesCount
      if (data.newsBean) {
        this.isThumbed = data.newsBean.isSupport
      }
    },
    goCommentPage() {
      const {title} = this.articleInfo
      this.$sa.trackSaEn('click_comment', {
        type: this.type,
        column_name: this.articleInfo.columnName,
        news_id: this.articleInfo.newsId,
        title: this.articleInfo.title
      })
      this.$router.push({
        name: 'launcher-article-comment',
        params: {
          id: this.articleId,
          newsId: this.articleInfo.newsId,
          title: title,
          path: this.currentRoute,
          url: window.location.href,
          columnName: this.articleInfo.columnName,
          columnCodes: this.articleInfo.columnCodes && this.articleInfo.columnCodes.join(','),
          type: this.type
        }
      })
    },
    async supportArticle() {
      this.isThumbed = !this.isThumbed
      if(this.isThumbed) {
        this.likeNum++
        await supportArticle(this.articleId, this.wechatUser.token, this.serviceConfig.appCode, this.serviceConfig.serverId)
        // this.$sa.track('like_article', {
        //   article: this.articleInfo.title,
        //   column: this.articleInfo.columnName
        // })
        this.$sa.trackSaEn('click_dianzan', {
          position: 'detailpage',
          type: this.type,
          news_id: this.articleInfo.newsId,
          title: this.articleInfo.title,
          column_name: this.articleInfo.columnName
        })
      }else {
        this.likeNum--
        await unSupportArticle(this.articleId, this.wechatUser.token, this.serviceConfig.appCode, this.serviceConfig.serverId)
      }
    },
    formatMsgContent (commentList) {
      const userComments = commentList.filter((comment) => {
        return !comment.parentId && comment.status === 1
      })
      const authorComments = commentList.filter((comment) => {
        return comment.parentId && comment.status === 1
      })
      userComments.forEach((userComment) => {
        authorComments.forEach((authorComment) => {
          if (authorComment.parentId === userComment.id) {
            userComment.authorComments ? userComment.authorComments.push(authorComment) : userComment.authorComments = [authorComment]
          }
        })
      })
      return userComments
    }
  },
  filters: {
    formatComment,
    formatTime
  }
}